import React from "react";
import { ImagePlusIcon } from "lucide-react";
type ImageSlotProps = {
  src?: string;
  alt: string;
  className?: string;
  placeholderLabel?: string;
};

// Mostra l'immagine se presente, altrimenti uno spazio da compilare.
export function ImageSlot({
  src,
  alt,
  className = "",
  placeholderLabel = "Inserisci immagine"
}: ImageSlotProps) {
  if (!src) {
    return <div className={`flex flex-col items-center justify-center gap-2 border-2 border-dashed border-line bg-chip/40 text-center text-muted ${className}`} role="img" aria-label={placeholderLabel} data-id="element-185" data-mp="2ej44b1m80bbj">
        <ImagePlusIcon className="h-8 w-8" strokeWidth={1.5} aria-hidden="true" data-id="element-186" data-mp="25hmsvwjrcxt6" />
        <span className="px-4 text-sm font-medium" data-id="element-187" data-mp="20jl7v62ruof2">{placeholderLabel}</span>
      </div>;
  }
  return <img src={src} alt={alt} className={`object-cover ${className}`} loading="lazy" data-id="element-188" data-mp="u2zjbgazsxd9" />;
}